import { render, staticRenderFns } from "./VFormCreate.vue?vue&type=template&id=f59ec52c"
import script from "./VFormCreate.vue?vue&type=script&lang=js"
export * from "./VFormCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports